import styled from 'styled-components';
import section1Background from '../../assets/images/section1_background.png';
import section1Image1 from '../../assets/images/section1_image1.png';
import section1Image2 from '../../assets/images/section1_image2.png';
import section1Image3 from '../../assets/images/section1_image3.png';
import section1Image4 from '../../assets/images/section1_image4.png';
import section1Image5 from '../../assets/images/section1_image5.png';
import section1Bottom from '../../assets/images/section1_bottom.png';
import section1Gif from '../../assets/gif/section1.gif';
import logo from '../../assets/gif/section1_logo.jpg';
import arrowRedIcon from '../../assets/icons/svg/arrow_red.svg';

const bp = { sm: '480px', md: '768px', lg: '1024px', xl: '1280px' };

const Section1Container = styled.section`
  position: relative;
  display: flex; flex-direction: column; align-items: center;
  width: 100%; max-width: 1440px; margin: 0 auto;
  padding: clamp(48px, 6vw, 120px) clamp(16px, 6vw, 80px) clamp(64px, 8vw, 140px);
  &::before {
    content: ""; position: absolute; inset: 0; z-index: 0;
    background: linear-gradient(180deg, rgba(255,255,255,0.85), #fff 60%);
  }
`;

const BackgroundImage = styled.img`
  position: absolute; inset: 0; z-index: -1;
  width: 100%; height: 100%; object-fit: contain; opacity: 0.25;
  user-select: none; pointer-events: none;
`;

const TitleWrapper = styled.div`
  position: relative; z-index: 1; text-align: center;
  display: flex; flex-direction: column; align-items: center;
  gap: clamp(8px, 1.8vw, 16px);
  h2 { font-size: clamp(24px, 4vw, 44px); font-weight: 800; color: #111827; line-height: 1.2; }
  h3 { font-size: clamp(14px, 2.4vw, 20px); font-weight: 500; color: #374151; line-height: 1.45; }
`;

const ContentWrapper = styled.div`
  position: relative; z-index: 1; width: 100%;
  display: flex; flex-direction: column; align-items: center;
  gap: clamp(28px, 6vw, 80px); margin-top: clamp(24px, 4vw, 48px);
`;

const ContentTopContainer = styled.div`
  width: 100%;
  display: grid; gap: clamp(20px, 4vw, 32px); grid-template-columns: 1fr;
  margin-top: clamp(12px, 3vw, 28px);
  @media (min-width: ${bp.md}) { grid-template-columns: 1fr 1fr; }
  @media (min-width: ${bp.xl}) { gap: 40px; }
`;

const ContentTopItem = styled.div`
  background: #fff; border: 1px solid #e5e7eb; border-radius: 24px;
  padding: clamp(16px, 3.5vw, 28px);
  box-shadow: 0 8px 30px rgba(17,24,39,0.06);
  display: flex; flex-direction: column; align-items: center;
  gap: clamp(12px, 2.5vw, 20px);
  h4 { font-size: clamp(18px, 2.6vw, 22px); font-weight: 700; color: #111827; }
`;

const ItemImagesWrapper = styled.div`
  width: 100%;
  border: 1px solid #e5e7eb; background: #fff; border-radius: 9999px;
  padding: clamp(12px, 3vw, 20px) clamp(14px, 4vw, 28px);
  display: grid; gap: clamp(12px, 3vw, 24px);
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-items: center; align-items: start;
  @media (min-width: ${bp.sm}) { grid-template-columns: repeat(3, minmax(0, 1fr)); }
`;

const ImageItem = styled.div`
  display: flex; flex-direction: column; align-items: center;
  gap: clamp(6px, 1.6vw, 12px);
  span { font-size: clamp(12px, 2.2vw, 16px); color: #374151; white-space: nowrap; }
`;

const ImageWrapper = styled.figure`
  display: grid; place-items: center;
  width: clamp(88px, 18vw, 160px); height: clamp(88px, 18vw, 160px);
  min-width: clamp(88px, 18vw, 160px); min-height: clamp(88px, 18vw, 160px);
  background: #f3f4f6; border-radius: 50%; overflow: hidden; border: 1px solid #e5e7eb;
  img { width: 100%; height: 100%; object-fit: contain; display: block; }
`;

const ContentBottomImageWrapper = styled.div`
  width: min(100%, 920px); aspect-ratio: 4 / 3; position: relative;
  border-radius: 24px; overflow: hidden;
  box-shadow: 0 16px 50px rgba(17,24,39,0.08);
`;

const ContentBottomImage = styled.img`
  position: absolute; inset: 0; width: 100%; height: 100%; object-fit: contain;
`;

const ContentBottomImageGif = styled.img`
  position: absolute;
  width: clamp(100px, 39%, 360px); aspect-ratio: 320 / 185;
  left: 28%; top: 63%; transform: translate(-8%, -48%);
  border-radius: 12px; box-shadow: 0 10px 24px rgba(0,0,0,0.16);
`;

const ContentBottomLogo = styled.img`
  position: absolute;
  width: clamp(30px, 12%, 120px); aspect-ratio: 5 / 3;
  right: 21%; bottom: 31%;
  border-radius: 8px; background: #fff; box-shadow: 0 6px 18px rgba(0,0,0,0.12);
`;

/* ✅ TS 제네릭/prop 없이 좌우 화살표를 각각 정의 */
const ArrowLeft = styled.img`
  position: absolute;
  top: calc(100% - clamp(140px, 16vw, 220px));
  left: clamp(8px, 6vw, 48px);
  width: clamp(20px, 3.2vw, 28px); height: auto; opacity: 0.8;
`;

const ArrowRight = styled.img`
  position: absolute;
  top: calc(100% - clamp(140px, 16vw, 220px));
  right: clamp(8px, 6vw, 48px);
  width: clamp(20px, 3.2vw, 28px); height: auto; opacity: 0.8;
  transform: scaleX(-1);
`;

function Section1() {
  return (
      <Section1Container>
        <BackgroundImage src={section1Background} alt="section1_background" draggable={false} />

        <TitleWrapper>
          <h3>
            {'<'}본 웹사이트는 PC환경에 최적화되어 있습니다.{'>'}
          </h3>
          <h2>지금은 디지털 광고시대!!</h2>
          <h3>지역의 종이 광고를 부동산중개소의 디지털사이니지로!</h3>
        </TitleWrapper>

        <ContentWrapper>
          <ContentTopContainer>
          <ContentTopItem>
              <h4>기존 광고방식</h4>
              <ItemImagesWrapper>
                <ImageItem>
                  <ImageWrapper><img src={section1Image1} alt="section1_image1" /></ImageWrapper>
                  <span>전단지</span>
                </ImageItem>
                <ImageItem>
                  <ImageWrapper><img src={section1Image2} alt="section1_image2" /></ImageWrapper>
                  <span>현수막</span>
                </ImageItem>
                <ImageItem>
                  <ImageWrapper><img src={section1Image3} alt="section1_image3" /></ImageWrapper>
                  <span>벽보</span>
                </ImageItem>
              </ItemImagesWrapper>
            </ContentTopItem>

            <ContentTopItem>
              <h4>부동산 창문광고</h4>
              <ItemImagesWrapper>
                <ImageItem>
                  <ImageWrapper><img src={section1Image4} alt="section1_image4" /></ImageWrapper>
                </ImageItem>
                <ImageItem>
                  <ImageWrapper><img src={section1Image5} alt="section1_image5" /></ImageWrapper>
                </ImageItem>
              </ItemImagesWrapper>
            </ContentTopItem>
          </ContentTopContainer>

          <ContentBottomImageWrapper>
            <ContentBottomImage src={section1Bottom} alt="section1_bottom" />
            <ContentBottomImageGif src={section1Gif} alt="section1_gif" />
            <ContentBottomLogo src={logo} alt="logo" />
          </ContentBottomImageWrapper>

          <ArrowLeft src={arrowRedIcon} alt="left_arrow_red" />
          <ArrowRight src={arrowRedIcon} alt="right_arrow_red" />
        </ContentWrapper>
      </Section1Container>
  );
}

export default Section1;
